import type { CompleteBankRefundInput } from '@repo/api-contracts';
import { useInvalidateOrders } from '@/entities/order';
import { useInvalidatePayments } from '@/entities/payment';
import { trpc } from '@/shared/api';

export const useCompleteBankRefund = (): ((input: CompleteBankRefundInput) => Promise<void>) => {
  const mutation = trpc.paymentManagement.completeBankRefund.useMutation();
  const orders = useInvalidateOrders();
  const payments = useInvalidatePayments();
  return async (input) => {
    await mutation.mutateAsync(input);
    await Promise.all([orders.detail(input.orderId), orders.list(), payments.list()]);
  };
};
